module.exports = __webpack_public_path__ + "static/media/dusk.cdc43f7a.svg";